<template>
  <div class="main print-no-padding">
    <h2 class="is-print-hide title-area">
      <span class="main-title">续费门店</span>
    </h2>
    <div class="list-content">
      <el-card class="renewal-store-table-box">
        <renewalStoreTable
          :page-no="searchParams.pageNo"
          :page-size="searchParams.pageSize"
          :data="data"
          :total="total"
          @handle-selection-change="handleSelectionChange"
          @handle-select="handleSelect"
          @handle-select-all="handleSelectAll"
          @handle-pageNo="handlePageNo"
          @handle-pageSize="handlePageSize"
        />
      </el-card>
      <packageConfig
        :packageList="packageList"
        :type="2"
        :selectedPackageCode="selectedPackageCode"
        :selectedLimitCode="selectedLimitCode"
        @selectPackage="onSelectPackage"
        @selectLimit="onSelectLimit"
      />
      <toPayFloatingBar
        :pointShow="true"
        :orderStoreSum="selectedStores.length"
        :orderAmount="totalPrice"
        btnText="提交订单"
        @btnClick="submit"
      />
    </div>
  </div>
</template>

<script>
import renewalStoreTable from './components/renewalStoreTable.vue';
import packageConfig from '../../../components/packageConfig/packageConfig.vue';
import toPayFloatingBar from '../../../components/toPayFloatingBar/toPayFloatingBar.vue';
import { mapActions } from 'vuex';
let selfJump = false;
export default {
  components: {
    renewalStoreTable,
    packageConfig,
    toPayFloatingBar
  },
  data() {
    return {
      searchParams: {
        pageNo: 1,
        pageSize: 10
      },
      data: [],
      total: 0,
      packageList: [],
      selectedPackage: {},
      selectedPackageCode: null,
      selectedLimitCode: null,
      selectedStores: []
    };
  },
  computed: {
    totalPrice() {
      const {
        selectedPackage: { packageUnitPrice },
        selectedLimitCode,
        selectedStores
      } = this;
      if (!selectedStores.length || !packageUnitPrice || !selectedLimitCode) return 0;
      return packageUnitPrice * selectedLimitCode * selectedStores.length;
    }
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions('renewal', ['submitRenewalOrder', 'hasRenewalOrderEntrance', 'hasUnpaidOrder']),
    change(key, val) {
      this.searchParams[key] = val;
    },
    init() {
      this.getRenewalStoreList(this.searchParams);
      this.getPackageConfig();
      this.hasRenewalOrderEntrance();
      this.hasUnpaidOrder('chain');
    },
    search() {
      this.getRenewalStoreList({ ...this.searchParams, pageNo: 1, pageSize: 10 });
    },

    resetSearchData() {
      this.searchParams = { ...this.searchParams };
    },
    async getRenewalStoreList(params) {
      const res = await Fetch.getRenewalStoreList({ ...params, isRenewal: true });
      this.data = res.data;
      this.total = res.totalCount;
    },
    handlePageNo(pageNo) {
      this.searchParams.pageNo = pageNo;
      return this.getRenewalStoreList({ ...this.searchParams });
    },
    handlePageSize(pageSize) {
      this.searchParams.pageSize = pageSize;
      return this.getRenewalStoreList({ ...this.searchParams });
    },
    handleSelectionChange(rows) {
      this.selectedStores = rows;
    },
    handleSelect(selection = [], row = {}) {
      // 只有选中的时候需要埋点
      const selectedItem = selection.filter(item => {
        return item.storeId == row.storeId;
      });
      if (selectedItem.length) {
        Telescope.trackEvent({ trackId: 'zywzpc-click-package-selectstores' });
      }
    },
    handleSelectAll(selection = []) {
      if (selection.length) {
        Telescope.trackEvent({ trackId: 'zywzpc-click-package-selectstores' });
      }
    },
    async getPackageConfig() {
      const res = await Fetch.getPackageConfig();
      this.packageList = res;
    },
    onSelectPackage(packageInfo) {
      const { packageCode, defaultPackageLimitCode } = packageInfo;
      this.selectedPackage = packageInfo;
      this.selectedPackageCode = packageCode;
      this.selectedLimitCode = defaultPackageLimitCode;
      Telescope.trackEvent({ trackId: 'zywzpc-click-package-choosepackage' });
    },
    onSelectLimit(limitInfo) {
      this.selectedLimitCode = limitInfo.packageLimitTimeCode;
      Telescope.trackEvent({ trackId: 'zywzpc-click-package-renewalterm' });
    },
    async submit() {
      Telescope.trackEvent({ trackId: 'zywzpc-event-wzy-fwtctjdd' });
      const { selectedPackageCode, selectedLimitCode, selectedStores, totalPrice } = this;
      if (!selectedStores.length || !selectedPackageCode || !selectedLimitCode) {
        this.$message({
          message: '请选择完整信息',
          type: 'warning'
        });
        return;
      }
      const storeIdList = selectedStores.map(v => v.storeId);
      const params = {
        packageCode: selectedPackageCode,
        packageLimitTimeCode: selectedLimitCode,
        storeIdList,
        payPrice: totalPrice,
        prefixes: 'chain'
      };
      selfJump = true;
      await this.submitRenewalOrder(params);
      selfJump = false;
    }
  },
  beforeRouteLeave(to, from, next) {
    if (selfJump) {
      next();
    } else {
      setTimeout(() => {
        this.$confirm('退出后此页面数据无法保留，是否确认退出？', '确定退出', {
          confirmButtonText: '退出',
          cancelButtonText: '取消',
          customClass: 'confirm',
          type: 'warning',
          center: true
        })
          .then(() => {
            next();
          })
          .catch(() => {
            next(false);
          });
      }, 0);
    }
  }
};
</script>

<style lang="scss" scoped>
.list-content {
  display: flex;
  padding-bottom: 56px;
  .renewal-store-table-box {
    box-shadow: none;
    border: none;
    border-radius: 0;
    flex: 1;
  }
}
</style>
